/*
 * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT
 *
 * Licensed under the MIT License. See the LICENSE accompanying this file
 * for the specific language governing permissions and limitations under
 * the License.
 */

import React from "react";
import { useAuthenticator, View, Button } from "@aws-amplify/ui-react";
import { I18n } from "@aws-amplify/core";
import handleIdPLogin from "../../helpers/handleIdpLogin";
import odvIcon from "../../assets/Idp/odv.png";

const SignInHeader = (conf) => {
	const isSAMLIdP = !!conf.SAMLIdPs.length;
	const SAMLLoginButtons = conf.SAMLIdPs.map((IdP) => {
		let IdpBtnText = "";
		switch (IdP) {
			case "ODV":
				IdpBtnText = (
					<span>
						<img src={odvIcon} alt="" className="idp-icons"></img>
						{I18n.get("Sign In with Order of Veterinarians")}
					</span>
				);
				break;
			case "Google":
				IdpBtnText = (
					<span>
						<svg
							aria-label="Google icon"
							class="idp-icons amplify-icon federated-sign-in-icon"
							viewBox="0 0 256 262"
							xmlns="http://www.w3.org/2000/svg"
							preserveAspectRatio="xMidYMid"
						>
							<path
								d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
								fill="#4285F4"
							></path>
							<path
								d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
								fill="#34A853"
							></path>
							<path
								d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
								fill="#FBBC05"
							></path>
							<path
								d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
								fill="#EB4335"
							></path>
						</svg>
						{I18n.get("Sign In with Google")}
					</span>
				);
				break;
			default:
				IdpBtnText = I18n.get(`LANDING_PAGE_BUTTON_IDP_${IdP}_LABEL`);
				break;
		}

		return (
			<button
				key={IdP}
				className="saml btn idp-button"
				onClick={() => handleIdPLogin(IdP)}
			>
				{IdpBtnText}
			</button>
		);
	});

	let divider = null;
	if (isSAMLIdP) {
		divider = (
			<hr
				aria-orientation="horizontal"
				className="amplify-divider amplify-divider--horizontal amplify-divider--small amplify-divider--label"
				data-size="small"
				data-label={I18n.get("or")}
			/>
		);
	}

	return (
		<div style={{ margin: "0px 32px" }}>
			<p className="sign-in-up-header">{I18n.get("Sign In")}</p>

			{SAMLLoginButtons}
			{divider}
		</div>
	);
};

const SignInFooter = (conf) => {
	const { toResetPassword, toSignUp } = useAuthenticator();

	const hideRegister = conf.hideRegister;
	const forceRegister = conf.forceRegister;

	if (forceRegister) {
		toSignUp();
	}

	if (hideRegister) {
		return (
			<View textAlign="center">
				<Button
					fontWeight="normal"
					onClick={toResetPassword}
					size="small"
					variation="link"
				>
					{I18n.get("Forgot your password?")}
				</Button>
			</View>
		);
	} else {
		return (
			<View textAlign="center">
				<Button
					fontWeight="normal"
					onClick={toResetPassword}
					size="small"
					variation="link"
				>
					{I18n.get("Forgot your password?")}
				</Button>

				<hr
					aria-orientation="horizontal"
					data-size="small"
					style={{ width: "87%", marginTop: "20px" }}
				/>
				<p
					style={{
						textAlign: "center",
						fontSize: "14px",
						color: "#554033",
						marginTop: "0",
					}}
				>
					{I18n.get("Do not have an account? ")}
					<Button
						fontWeight="normal"
						onClick={toSignUp}
						size="small"
						variation="link"
					>
						{I18n.get("Sign Up")}
					</Button>
				</p>
			</View>
		);
	}
};

export { SignInHeader, SignInFooter };
